i18nInterceptor.$inject = ['$injector'];
export function i18nInterceptor($injector) {
	return {
		request: async function (config) {
			const i18nService = $injector.get('mx.shell.InternationalizationService');
			config.headers['Explicit-Language'] = config.headers['Explicit-Language'] || i18nService.currentLanguage.code;
			config.headers['Accept-Language'] = config.headers['Accept-Language'] || i18nService.currentLanguage.code;
			return config;
		},
	};
}
